// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-header[data-v-0b8b53c6] {\n  height: 49vh;\n}", "",{"version":3,"sources":["webpack://./resources/ts/frontend/components/PagesHeader.vue"],"names":[],"mappings":"AAEI;EACI,YAAA;AADR","sourcesContent":["\r\n\r\n    .pages-header {\r\n        height: 49vh;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
